import { render, staticRenderFns } from "./OtpLogin.vue?vue&type=template&id=6827693d&scoped=true"
import script from "./OtpLogin.vue?vue&type=script&lang=js"
export * from "./OtpLogin.vue?vue&type=script&lang=js"
import style0 from "./OtpLogin.vue?vue&type=style&index=0&id=6827693d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6827693d",
  null
  
)

export default component.exports